import { StatusBar } from 'expo-status-bar';
import 'react-native-gesture-handler';
import 'react-native-reanimated'
import React, { Component } from 'react';
import { useState } from 'react';
import { Text, ImageBackground, View, Image, Alert, TouchableOpacity, Platform, Dimensions } from 'react-native';
import * as WebBrowser from 'expo-web-browser';
import { setAnalyticsCollectionEnabled } from 'expo-firebase-analytics';
import 'react-native-gesture-handler';
import api from '../config/api_urls';
//Style caixeti
import style from '../credits/style';
import AsyncStorage from '@react-native-community/async-storage';
import * as Device from 'expo-device';
import getDevice from '../functions/getDevice';


class Main  extends Component  {
        constructor(props) {
      super(props);
      this.state = { loadedData: false, fontLoaded: false , idioma : props.route.params.idioma,};
      this.changed = false;
      this.state['veDePerfil'] = true
      this.state['pop_up_height'] = Dimensions.get('screen').height * (13 / 15) * 0.67;
      this.state['pop_up_margin_top'] = Dimensions.get('screen').height * (13 / 15) * 0.22;
      this.state['width'] = Dimensions.get('screen').width;
      this.state['height'] = Dimensions.get('screen').height;
      this.state['nom'] = null;
      this.state['device'] = null;
    //   this.state['idioma'] = aux;
    }
  
  
    
   componentDidMount() {
      getDevice().then((res) => {
        this.setState({device: res});
      });
      this.getData()
      this.getMostarCredits() 
      this.getNom()
    }
  
    getLastPoiTrucada = async () => {
      try {
        const value = await AsyncStorage.getItem('lastPoiTrucada');
      //  console.log(value);
          if (value !== null) {
           this.state.premiTrucada = JSON.parse(value);
           this.props.navigation.navigate('Video', this.state);
          }else{
            this.setState({loadedData: true});
          }
      }catch (e) {
          console.log(e);
      }
    }
  
    getNom = async () => {
        try{
          const value = await AsyncStorage.getItem('nom');
          if(value !== null){
            this.setState({nom: value});
          }
        }catch(e){
          console.log(e);
        }
      }

    getMostarCredits = async () => {
      try {
        const value = await AsyncStorage.getItem('anarCredits');
      //  console.log(value);
        if (value !== null) {
          if(value == "false" || value == false){
            this.setState({veDePerfil : false })
          }
        }  
      } catch (e) {
        console.log(e);
        
      }
    }
     
    getData() {
      return fetch(api.sitges,{
        method: 'GET',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          // console.log("Data obtained...");
          // console.log(responseJson);
          this.setState(
            {
              itemId: 856,
              projecte: responseJson[0],
              recursos: responseJson[0].recursos,
              urlImatgeInicial: (responseJson[0]['ImatgeInicial'+this.state.idioma] != null) ? api.api_url + responseJson[0]['ImatgeInicial'+this.state.idioma].url : "",
            },
            function () { this.getLastPoiTrucada()}
          );
  
          if (this.state.urlImatgeInicial == "")  this.changeScreen();
  
        })
        .catch(error => {
          console.error(error);
        });
    }
  
    changeScreen() {
      if (!this.changed){
        if(!this.state.veDePerfil){
          this.props.navigation.navigate('Home', this.state);
          this.changed = true;
        }else{
        if(this.state.nom != null)
        {
            this.props.navigation.navigate('Home', this.state);
            // this.props.navigation.navigate('Telefon', this.state);

        }else
        {
            this.props.navigation.navigate('Login', this.state); 
        }
         this.changed = true;
        }
        height:(Dimensions.get('screen').height/100)*80
        }
    }
  
  
    mostrarPaginaPrincipal(){
      if(this.state.projecte.MostrarPantallaLogos && this.state.veDePerfil){
        if(this.state.projecte.MostrarTextExplicatiu){
          return(
             
                <View style={{ flex: 1, alignContent:'center', alignSelf:'center' }}>
                  <Image source={this.state.projecte.ImatgePrincipalTextExplicatiu ?{ uri: api.api_url + this.state.projecte.ImatgePrincipalTextExplicatiu.url } : null} style={{ height: this.state.pop_up_height * 0.6, width: this.state.pop_up_height * 0.6,resizeMode: 'contain', alignSelf:'center' }} />
                  <View style={{flexDirection:'row', alignSelf:'center', paddingTop:15}}>
                    <Text style={{ fontFamily: 'Lobster', fontSize: 21, textAlign: "center",color: "#006fb7", fontSize: 25, paddingBottom:20 }}>
                      {this.state.projecte['TextExplicatiu'+this.state.idioma]}
                    </Text>
                    <TouchableOpacity onPress={() =>{this._handlePressButtonAsync(this.state.projecte.UrlTextExplicatiu ? this.state.projecte.UrlTextExplicatiu : null )}}>
                      <Image source={this.state.projecte.ImatgeBotoTextExplicatiu ?{ uri: api.api_url + this.state.projecte.ImatgeBotoTextExplicatiu.url } : null} style={{ height: this.state.pop_up_height * 0.2, width: this.state.pop_up_height * 0.2,resizeMode: 'contain', alignSelf:'center' }} />
                    </TouchableOpacity>
                  </View>
                </View>
            
          )
        }else{
        if(this.state.projecte.MostrarCaixeti){
          return(
          <View style={{ flex: 1,}}>
             <View style={[style.caixaOut, {backgroundColor: this.state.projecte.colorPrincipal2}]}>
                <View style={[style.caixa,this.state.projecte.BorderContenidor ? style.caixaBorderContenidor : null , { borderColor: this.state.projecte.ColorBorderContenidor } ]}>
                  <Text style={{ fontFamily: 'Lobster', fontSize: 21, textAlign: "center", paddingTop: 5, paddingBottom: 10, color: "white", fontSize: 28 }}>
                    {this.state.projecte['TitolPantallaLogos'+this.state.idioma]}
                  </Text>
                  <Image style={{ height: this.state.pop_up_height * 0.8, resizeMode: 'contain' }} source={{ uri: this.state.urlImatgeInicial }} />
                </View>
              </View>
            </View>
            )
        }else{
          return (
                 <View style={{ alignContent: 'center' }}>
                   
                   <Image style={{ height: this.state.pop_up_height * 0.95, resizeMode: 'contain' }} source={{ uri: this.state.urlImatgeInicial }} />
                 </View>
          )
        }
      }
      }else{
        this.changeScreen();
      }
    }
    
      _handlePressButtonAsync = async (link) => {
        let result = await WebBrowser.openBrowserAsync(link);
      };
  
    render() {
    
    
      if (this.state.loadedData) {

        if(this.state.device != "phone" && this.state.device != "tablet" && this.state.device != "unknown")
        {
          return(
            <ImageBackground
            source={{uri: api.api_url + this.state.projecte.recursos.find(e => e.tipus_recurs == '01_background_qr')['imatge_recurs' + this.state.idioma]?.url}}
            style={{flex:1,width:'100vw',height:'100%',resizeMode:'contain'}}>
          </ImageBackground>
          )
        }else{
          return (
            <View style={{ flex: 1 }}>
              <TouchableOpacity style={{flex:1}}  onPress={() =>{ this.changeScreen();}}>
                <ImageBackground source={{ uri: this.state.urlImatgeInicial }} >
                  <View style={{ marginTop: this.state.pop_up_margin_top * 0.5, height: (this.state.pop_up_height * 1.5) }}>     
                    {/* {
                     this.mostrarPaginaPrincipal()
                    } */}
                  </View>
                </ImageBackground>
              </TouchableOpacity>
            </View>
          )   
      }
    } else {
      return (
        <View style={{ flex: 1, justifyContent: 'center' }}>
          <TouchableOpacity>
            <Image style={{ alignSelf: 'center', width: 150, height: 150, marginTop: 10 }} source={require('../../img/loading.gif')} />
          </TouchableOpacity>
        </View>
      )
    }
  }
  }


  export default Main;